import { Component } from '@angular/core';

@Component({
    selector: '<error-404></error-404>',
    templateUrl: './pagenotfound.component.html'
})
export class PageNotFoundComponent {

}